import { computed } from "mobx";
import { Store, StoreStandardParams } from "../../WSUtils/Store";
import { CVEditContextStore } from "./CVEditContext";

export interface CVEditStoreParams extends StoreStandardParams {
  getCvEditContext: () => CVEditContextStore;
}

export class CVEditStore<
  T extends CVEditStoreParams = CVEditStoreParams
> extends Store<T> {
  getCvEditContext: () => CVEditContextStore;
  @computed get cvEditContext() {
    return this.getCvEditContext();
  }
}
